import icono_whatsapp_footer from "./Recursos/icono_whatsapp_footer.svg";
import icono_facebook_footer from "./Recursos/icono_facebook_footer.svg";
import icono_instagram_footer from "./Recursos/icono_instagram_footer.svg";

export const NUMEROATENCION = '3127053949'
export const REDES = [
    {imagen: icono_whatsapp_footer, alt: 'Whatsapp', url: `https://api.whatsapp.com/send?phone=57${NUMEROATENCION}`},
    {imagen: icono_facebook_footer, alt: 'Facebook', url: 'https://www.facebook.com/congeladosdenarino'},
    {imagen: icono_instagram_footer, alt: 'Instagram', url: 'https://www.instagram.com/congenar/'},
];

export const SECCIONES = [
    {nombre: 'HOME', ruta: '/'},
    {nombre: 'OFERTAS', ruta: '/ofertas'},
    {nombre: 'MIS COMPRAS', ruta: '/mis-compras'},
]

